// @generated by protoc-gen-es v2.12.1 with parameter "target=ts,json_types=true"
// @generated from file integrations/v1/service.proto (package integrations.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_common_v1_annotations } from "../../common/v1/annotations_pb";
import { file_google_api_annotations } from "../../google/api/annotations_pb";
import type { ExitStatus, ExitStatusJson, SyncResult, SyncResultJson } from "./sync_pb";
import { file_integrations_v1_sync } from "./sync_pb";
import type { ProxyRequestSchema, ProxyResponseSchema } from "./proxy_pb";
import { file_integrations_v1_proxy } from "./proxy_pb";
import type { Connection, ConnectionJson, Integration, IntegrationCategory, IntegrationCategoryJson, IntegrationJson, Marketplace, MarketplaceJson, WorkspaceTenant, WorkspaceTenantJson } from "./integration_pb";
import { file_integrations_v1_integration } from "./integration_pb";
import { file_integrations_v1_sink } from "./sink_pb";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_integrations_v1_connector } from "./connector_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file integrations/v1/service.proto.
 */
export const file_integrations_v1_service: GenFile =
	/*@__PURE__*/
	fileDesc(
		"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",
		[file_common_v1_annotations, file_google_api_annotations, file_integrations_v1_sync, file_integrations_v1_proxy, file_integrations_v1_integration, file_integrations_v1_sink, file_google_protobuf_timestamp, file_integrations_v1_connector],
	);

/**
 * Request for fetching the URL to the integration app marketplace
 *
 * @generated from message integrations.v1.GetMarketplaceURLRequest
 */
export type GetMarketplaceURLRequest = Message<"integrations.v1.GetMarketplaceURLRequest"> & {
	/**
	 * org id of the user requester of the integrations marketplace
	 *
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * workspace id of the requester where the connections will live
	 *
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * used for user-defined name of the tenant in the backend (we can change this to be a lookup later)
	 *
	 * @generated from field: string workspace_name = 3;
	 */
	workspaceName: string;
};

/**
 * Request for fetching the URL to the integration app marketplace
 *
 * @generated from message integrations.v1.GetMarketplaceURLRequest
 */
export type GetMarketplaceURLRequestJson = {
	/**
	 * org id of the user requester of the integrations marketplace
	 *
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * workspace id of the requester where the connections will live
	 *
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * used for user-defined name of the tenant in the backend (we can change this to be a lookup later)
	 *
	 * @generated from field: string workspace_name = 3;
	 */
	workspaceName?: string;
};

/**
 * Describes the message integrations.v1.GetMarketplaceURLRequest.
 * Use `create(GetMarketplaceURLRequestSchema)` to create a new message.
 */
export const GetMarketplaceURLRequestSchema: GenMessage<GetMarketplaceURLRequest, { jsonType: GetMarketplaceURLRequestJson }> = /*@__PURE__*/ messageDesc(file_integrations_v1_service, 0);

/**
 * Response containing the URL to the integration app marketplace
 *
 * @generated from message integrations.v1.GetMarketplaceURLResponse
 */
export type GetMarketplaceURLResponse = Message<"integrations.v1.GetMarketplaceURLResponse"> & {
	/**
	 * @generated from field: string marketplace_url = 1;
	 */
	marketplaceUrl: string;
};

/**
 * Response containing the URL to the integration app marketplace
 *
 * @generated from message integrations.v1.GetMarketplaceURLResponse
 */
export type GetMarketplaceURLResponseJson = {
	/**
	 * @generated from field: string marketplace_url = 1;
	 */
	marketplaceUrl?: string;
};

/**
 * Describes the message integrations.v1.GetMarketplaceURLResponse.
 * Use `create(GetMarketplaceURLResponseSchema)` to create a new message.
 */
export const GetMarketplaceURLResponseSchema: GenMessage<GetMarketplaceURLResponse, { jsonType: GetMarketplaceURLResponseJson }> = /*@__PURE__*/ messageDesc(file_integrations_v1_service, 1);

/**
 * Request to save the results of an integration sync
 *
 * @generated from message integrations.v1.SaveSyncResultRequest
 */
export type SaveSyncResultRequest = Message<"integrations.v1.SaveSyncResultRequest"> & {
	/**
	 * @generated from field: integrations.v1.SyncResult result = 1;
	 */
	result?: SyncResult | undefined;
};

/**
 * Request to save the results of an integration sync
 *
 * @generated from message integrations.v1.SaveSyncResultRequest
 */
export type SaveSyncResultRequestJson = {
	/**
	 * @generated from field: integrations.v1.SyncResult result = 1;
	 */
	result?: SyncResultJson;
};

/**
 * Describes the message integrations.v1.SaveSyncResultRequest.
 * Use `create(SaveSyncResultRequestSchema)` to create a new message.
 */
export const SaveSyncResultRequestSchema: GenMessage<SaveSyncResultRequest, { jsonType: SaveSyncResultRequestJson }> = /*@__PURE__*/ messageDesc(file_integrations_v1_service, 2);

/**
 * Empty response to an integration sync save
 *
 * @generated from message integrations.v1.SaveSyncResultResponse
 */
export type SaveSyncResultResponse = Message<"integrations.v1.SaveSyncResultResponse"> & {};

/**
 * Empty response to an integration sync save
 *
 * @generated from message integrations.v1.SaveSyncResultResponse
 */
export type SaveSyncResultResponseJson = {};

/**
 * Describes the message integrations.v1.SaveSyncResultResponse.
 * Use `create(SaveSyncResultResponseSchema)` to create a new message.
 */
export const SaveSyncResultResponseSchema: GenMessage<SaveSyncResultResponse, { jsonType: SaveSyncResultResponseJson }> = /*@__PURE__*/ messageDesc(file_integrations_v1_service, 3);

/**
 * Request to retrieve the results of the most recent
 * integration sync for a workspace integration
 *
 * @generated from message integrations.v1.GetMostRecentSyncResultRequest
 */
export type GetMostRecentSyncResultRequest = Message<"integrations.v1.GetMostRecentSyncResultRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string integration_id = 3;
	 */
	integrationId: string;

	/**
	 * optionally provide an exit status to return the latest result of a specific status
	 *
	 * @generated from field: optional integrations.v1.ExitStatus exit_status = 4;
	 */
	exitStatus?: ExitStatus | undefined;
};

/**
 * Request to retrieve the results of the most recent
 * integration sync for a workspace integration
 *
 * @generated from message integrations.v1.GetMostRecentSyncResultRequest
 */
export type GetMostRecentSyncResultRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string integration_id = 3;
	 */
	integrationId?: string;

	/**
	 * optionally provide an exit status to return the latest result of a specific status
	 *
	 * @generated from field: optional integrations.v1.ExitStatus exit_status = 4;
	 */
	exitStatus?: ExitStatusJson;
};

/**
 * Describes the message integrations.v1.GetMostRecentSyncResultRequest.
 * Use `create(GetMostRecentSyncResultRequestSchema)` to create a new message.
 */
export const GetMostRecentSyncResultRequestSchema: GenMessage<GetMostRecentSyncResultRequest, { jsonType: GetMostRecentSyncResultRequestJson }> = /*@__PURE__*/ messageDesc(file_integrations_v1_service, 4);

/**
 * Response that contains the result of the most recent sync
 *
 * @generated from message integrations.v1.GetMostRecentSyncResultResponse
 */
export type GetMostRecentSyncResultResponse = Message<"integrations.v1.GetMostRecentSyncResultResponse"> & {
	/**
	 * @generated from field: integrations.v1.SyncResult result = 1;
	 */
	result?: SyncResult | undefined;
};

/**
 * Response that contains the result of the most recent sync
 *
 * @generated from message integrations.v1.GetMostRecentSyncResultResponse
 */
export type GetMostRecentSyncResultResponseJson = {
	/**
	 * @generated from field: integrations.v1.SyncResult result = 1;
	 */
	result?: SyncResultJson;
};

/**
 * Describes the message integrations.v1.GetMostRecentSyncResultResponse.
 * Use `create(GetMostRecentSyncResultResponseSchema)` to create a new message.
 */
export const GetMostRecentSyncResultResponseSchema: GenMessage<GetMostRecentSyncResultResponse, { jsonType: GetMostRecentSyncResultResponseJson }> = /*@__PURE__*/ messageDesc(file_integrations_v1_service, 5);

/**
 * Request to retrieve a summary of sync results
 *
 * @generated from message integrations.v1.GetSyncSummaryRequest
 */
export type GetSyncSummaryRequest = Message<"integrations.v1.GetSyncSummaryRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string integration_id = 3;
	 */
	integrationId: string;
};

/**
 * Request to retrieve a summary of sync results
 *
 * @generated from message integrations.v1.GetSyncSummaryRequest
 */
export type GetSyncSummaryRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string integration_id = 3;
	 */
	integrationId?: string;
};

/**
 * Describes the message integrations.v1.GetSyncSummaryRequest.
 * Use `create(GetSyncSummaryRequestSchema)` to create a new message.
 */
export const GetSyncSummaryRequestSchema: GenMessage<GetSyncSummaryRequest, { jsonType: GetSyncSummaryRequestJson }> = /*@__PURE__*/ messageDesc(file_integrations_v1_service, 6);

/**
 * Response that contains summary info for a particular
 * workspace integration
 *
 * @generated from message integrations.v1.GetSyncSummaryResponse
 */
export type GetSyncSummaryResponse = Message<"integrations.v1.GetSyncSummaryResponse"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string integration_id = 3;
	 */
	integrationId: string;

	/**
	 * @generated from field: int32 total_records_read = 4;
	 */
	totalRecordsRead: number;

	/**
	 * @generated from field: int32 total_records_written = 5;
	 */
	totalRecordsWritten: number;

	/**
	 * @generated from field: int32 total_records_failed = 6;
	 */
	totalRecordsFailed: number;

	/**
	 * @generated from field: int32 total_records_skipped = 7;
	 */
	totalRecordsSkipped: number;
};

/**
 * Response that contains summary info for a particular
 * workspace integration
 *
 * @generated from message integrations.v1.GetSyncSummaryResponse
 */
export type GetSyncSummaryResponseJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string integration_id = 3;
	 */
	integrationId?: string;

	/**
	 * @generated from field: int32 total_records_read = 4;
	 */
	totalRecordsRead?: number;

	/**
	 * @generated from field: int32 total_records_written = 5;
	 */
	totalRecordsWritten?: number;

	/**
	 * @generated from field: int32 total_records_failed = 6;
	 */
	totalRecordsFailed?: number;

	/**
	 * @generated from field: int32 total_records_skipped = 7;
	 */
	totalRecordsSkipped?: number;
};

/**
 * Describes the message integrations.v1.GetSyncSummaryResponse.
 * Use `create(GetSyncSummaryResponseSchema)` to create a new message.
 */
export const GetSyncSummaryResponseSchema: GenMessage<GetSyncSummaryResponse, { jsonType: GetSyncSummaryResponseJson }> = /*@__PURE__*/ messageDesc(file_integrations_v1_service, 7);

/**
 * @generated from message integrations.v1.IntegrationFilter
 */
export type IntegrationFilter = Message<"integrations.v1.IntegrationFilter"> & {
	/**
	 * @generated from field: optional integrations.v1.IntegrationCategory category = 1;
	 */
	category?: IntegrationCategory | undefined;
};

/**
 * @generated from message integrations.v1.IntegrationFilter
 */
export type IntegrationFilterJson = {
	/**
	 * @generated from field: optional integrations.v1.IntegrationCategory category = 1;
	 */
	category?: IntegrationCategoryJson;
};

/**
 * Describes the message integrations.v1.IntegrationFilter.
 * Use `create(IntegrationFilterSchema)` to create a new message.
 */
export const IntegrationFilterSchema: GenMessage<IntegrationFilter, { jsonType: IntegrationFilterJson }> = /*@__PURE__*/ messageDesc(file_integrations_v1_service, 8);

/**
 * Request to list proxy integrations. Installations for the provided
 * workspace information will be hydrated on each proxy integration.
 *
 * @generated from message integrations.v1.GetMarketplaceRequest
 */
export type GetMarketplaceRequest = Message<"integrations.v1.GetMarketplaceRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string workspace_name = 3;
	 */
	workspaceName: string;

	/**
	 * @generated from field: optional integrations.v1.IntegrationFilter filter = 4;
	 */
	filter?: IntegrationFilter | undefined;
};

/**
 * Request to list proxy integrations. Installations for the provided
 * workspace information will be hydrated on each proxy integration.
 *
 * @generated from message integrations.v1.GetMarketplaceRequest
 */
export type GetMarketplaceRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string workspace_name = 3;
	 */
	workspaceName?: string;

	/**
	 * @generated from field: optional integrations.v1.IntegrationFilter filter = 4;
	 */
	filter?: IntegrationFilterJson;
};

/**
 * Describes the message integrations.v1.GetMarketplaceRequest.
 * Use `create(GetMarketplaceRequestSchema)` to create a new message.
 */
export const GetMarketplaceRequestSchema: GenMessage<GetMarketplaceRequest, { jsonType: GetMarketplaceRequestJson }> = /*@__PURE__*/ messageDesc(file_integrations_v1_service, 9);

/**
 * @generated from message integrations.v1.GetMarketplaceResponse
 */
export type GetMarketplaceResponse = Message<"integrations.v1.GetMarketplaceResponse"> & {
	/**
	 * @generated from field: integrations.v1.Marketplace marketplace = 1;
	 */
	marketplace?: Marketplace | undefined;
};

/**
 * @generated from message integrations.v1.GetMarketplaceResponse
 */
export type GetMarketplaceResponseJson = {
	/**
	 * @generated from field: integrations.v1.Marketplace marketplace = 1;
	 */
	marketplace?: MarketplaceJson;
};

/**
 * Describes the message integrations.v1.GetMarketplaceResponse.
 * Use `create(GetMarketplaceResponseSchema)` to create a new message.
 */
export const GetMarketplaceResponseSchema: GenMessage<GetMarketplaceResponse, { jsonType: GetMarketplaceResponseJson }> = /*@__PURE__*/ messageDesc(file_integrations_v1_service, 10);

/**
 * Request to save the result of a successful connection
 *
 * @generated from message integrations.v1.SaveWorkspaceTenantRequest
 */
export type SaveWorkspaceTenantRequest = Message<"integrations.v1.SaveWorkspaceTenantRequest"> & {
	/**
	 * org id in which the integration was installed
	 *
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * workspace id in which the integration was installed
	 *
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * the unique ID of the installation (tenant ID)
	 *
	 * @generated from field: string tenant_id = 3;
	 */
	tenantId: string;

	/**
	 * the ID of the integration. For proxy integrations, this is the ID field.
	 *
	 * @generated from field: string integration_id = 4;
	 */
	integrationId: string;
};

/**
 * Request to save the result of a successful connection
 *
 * @generated from message integrations.v1.SaveWorkspaceTenantRequest
 */
export type SaveWorkspaceTenantRequestJson = {
	/**
	 * org id in which the integration was installed
	 *
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * workspace id in which the integration was installed
	 *
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * the unique ID of the installation (tenant ID)
	 *
	 * @generated from field: string tenant_id = 3;
	 */
	tenantId?: string;

	/**
	 * the ID of the integration. For proxy integrations, this is the ID field.
	 *
	 * @generated from field: string integration_id = 4;
	 */
	integrationId?: string;
};

/**
 * Describes the message integrations.v1.SaveWorkspaceTenantRequest.
 * Use `create(SaveWorkspaceTenantRequestSchema)` to create a new message.
 */
export const SaveWorkspaceTenantRequestSchema: GenMessage<SaveWorkspaceTenantRequest, { jsonType: SaveWorkspaceTenantRequestJson }> = /*@__PURE__*/ messageDesc(file_integrations_v1_service, 11);

/**
 * @generated from message integrations.v1.SaveWorkspaceTenantResponse
 */
export type SaveWorkspaceTenantResponse = Message<"integrations.v1.SaveWorkspaceTenantResponse"> & {};

/**
 * @generated from message integrations.v1.SaveWorkspaceTenantResponse
 */
export type SaveWorkspaceTenantResponseJson = {};

/**
 * Describes the message integrations.v1.SaveWorkspaceTenantResponse.
 * Use `create(SaveWorkspaceTenantResponseSchema)` to create a new message.
 */
export const SaveWorkspaceTenantResponseSchema: GenMessage<SaveWorkspaceTenantResponse, { jsonType: SaveWorkspaceTenantResponseJson }> = /*@__PURE__*/ messageDesc(file_integrations_v1_service, 12);

/**
 * @generated from message integrations.v1.DeleteWorkspaceTenantRequest
 */
export type DeleteWorkspaceTenantRequest = Message<"integrations.v1.DeleteWorkspaceTenantRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string tenant_id = 3;
	 */
	tenantId: string;
};

/**
 * @generated from message integrations.v1.DeleteWorkspaceTenantRequest
 */
export type DeleteWorkspaceTenantRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string tenant_id = 3;
	 */
	tenantId?: string;
};

/**
 * Describes the message integrations.v1.DeleteWorkspaceTenantRequest.
 * Use `create(DeleteWorkspaceTenantRequestSchema)` to create a new message.
 */
export const DeleteWorkspaceTenantRequestSchema: GenMessage<DeleteWorkspaceTenantRequest, { jsonType: DeleteWorkspaceTenantRequestJson }> = /*@__PURE__*/ messageDesc(file_integrations_v1_service, 13);

/**
 * @generated from message integrations.v1.DeleteWorkspaceTenantResponse
 */
export type DeleteWorkspaceTenantResponse = Message<"integrations.v1.DeleteWorkspaceTenantResponse"> & {};

/**
 * @generated from message integrations.v1.DeleteWorkspaceTenantResponse
 */
export type DeleteWorkspaceTenantResponseJson = {};

/**
 * Describes the message integrations.v1.DeleteWorkspaceTenantResponse.
 * Use `create(DeleteWorkspaceTenantResponseSchema)` to create a new message.
 */
export const DeleteWorkspaceTenantResponseSchema: GenMessage<DeleteWorkspaceTenantResponse, { jsonType: DeleteWorkspaceTenantResponseJson }> = /*@__PURE__*/ messageDesc(file_integrations_v1_service, 14);

/**
 * @generated from message integrations.v1.GetWorkspaceTenantRequest
 */
export type GetWorkspaceTenantRequest = Message<"integrations.v1.GetWorkspaceTenantRequest"> & {
	/**
	 * @generated from field: string workspace_tenant_id = 1;
	 */
	workspaceTenantId: string;
};

/**
 * @generated from message integrations.v1.GetWorkspaceTenantRequest
 */
export type GetWorkspaceTenantRequestJson = {
	/**
	 * @generated from field: string workspace_tenant_id = 1;
	 */
	workspaceTenantId?: string;
};

/**
 * Describes the message integrations.v1.GetWorkspaceTenantRequest.
 * Use `create(GetWorkspaceTenantRequestSchema)` to create a new message.
 */
export const GetWorkspaceTenantRequestSchema: GenMessage<GetWorkspaceTenantRequest, { jsonType: GetWorkspaceTenantRequestJson }> = /*@__PURE__*/ messageDesc(file_integrations_v1_service, 15);

/**
 * @generated from message integrations.v1.GetWorkspaceTenantResponse
 */
export type GetWorkspaceTenantResponse = Message<"integrations.v1.GetWorkspaceTenantResponse"> & {
	/**
	 * @generated from field: integrations.v1.WorkspaceTenant workspace_tenant = 1;
	 */
	workspaceTenant?: WorkspaceTenant | undefined;

	/**
	 * @generated from field: integrations.v1.Integration integration = 2;
	 */
	integration?: Integration | undefined;
};

/**
 * @generated from message integrations.v1.GetWorkspaceTenantResponse
 */
export type GetWorkspaceTenantResponseJson = {
	/**
	 * @generated from field: integrations.v1.WorkspaceTenant workspace_tenant = 1;
	 */
	workspaceTenant?: WorkspaceTenantJson;

	/**
	 * @generated from field: integrations.v1.Integration integration = 2;
	 */
	integration?: IntegrationJson;
};

/**
 * Describes the message integrations.v1.GetWorkspaceTenantResponse.
 * Use `create(GetWorkspaceTenantResponseSchema)` to create a new message.
 */
export const GetWorkspaceTenantResponseSchema: GenMessage<GetWorkspaceTenantResponse, { jsonType: GetWorkspaceTenantResponseJson }> = /*@__PURE__*/ messageDesc(file_integrations_v1_service, 16);

/**
 * @generated from message integrations.v1.ListWorkspaceConnectionsRequest
 */
export type ListWorkspaceConnectionsRequest = Message<"integrations.v1.ListWorkspaceConnectionsRequest"> & {
	/**
	 * @generated from field: optional string org_id = 1;
	 */
	orgId?: string | undefined;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;
};

/**
 * @generated from message integrations.v1.ListWorkspaceConnectionsRequest
 */
export type ListWorkspaceConnectionsRequestJson = {
	/**
	 * @generated from field: optional string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;
};

/**
 * Describes the message integrations.v1.ListWorkspaceConnectionsRequest.
 * Use `create(ListWorkspaceConnectionsRequestSchema)` to create a new message.
 */
export const ListWorkspaceConnectionsRequestSchema: GenMessage<ListWorkspaceConnectionsRequest, { jsonType: ListWorkspaceConnectionsRequestJson }> = /*@__PURE__*/ messageDesc(file_integrations_v1_service, 17);

/**
 * @generated from message integrations.v1.ListWorkspaceConnectionsResponse
 */
export type ListWorkspaceConnectionsResponse = Message<"integrations.v1.ListWorkspaceConnectionsResponse"> & {
	/**
	 * @generated from field: repeated integrations.v1.Connection connections = 1;
	 */
	connections: Connection[];
};

/**
 * @generated from message integrations.v1.ListWorkspaceConnectionsResponse
 */
export type ListWorkspaceConnectionsResponseJson = {
	/**
	 * @generated from field: repeated integrations.v1.Connection connections = 1;
	 */
	connections?: ConnectionJson[];
};

/**
 * Describes the message integrations.v1.ListWorkspaceConnectionsResponse.
 * Use `create(ListWorkspaceConnectionsResponseSchema)` to create a new message.
 */
export const ListWorkspaceConnectionsResponseSchema: GenMessage<ListWorkspaceConnectionsResponse, { jsonType: ListWorkspaceConnectionsResponseJson }> = /*@__PURE__*/ messageDesc(file_integrations_v1_service, 18);

/**
 * @generated from service integrations.v1.IntegrationsService
 */
export const IntegrationsService: GenService<{
	/**
	 * @generated from rpc integrations.v1.IntegrationsService.ListWorkspaceConnections
	 */
	listWorkspaceConnections: {
		methodKind: "unary";
		input: typeof ListWorkspaceConnectionsRequestSchema;
		output: typeof ListWorkspaceConnectionsResponseSchema;
	};
	/**
	 * @generated from rpc integrations.v1.IntegrationsService.GetWorkspaceTenant
	 */
	getWorkspaceTenant: {
		methodKind: "unary";
		input: typeof GetWorkspaceTenantRequestSchema;
		output: typeof GetWorkspaceTenantResponseSchema;
	};
	/**
	 * @generated from rpc integrations.v1.IntegrationsService.GetMarketplaceURL
	 */
	getMarketplaceURL: {
		methodKind: "unary";
		input: typeof GetMarketplaceURLRequestSchema;
		output: typeof GetMarketplaceURLResponseSchema;
	};
	/**
	 * @generated from rpc integrations.v1.IntegrationsService.GetMarketplace
	 */
	getMarketplace: {
		methodKind: "unary";
		input: typeof GetMarketplaceRequestSchema;
		output: typeof GetMarketplaceResponseSchema;
	};
	/**
	 * @generated from rpc integrations.v1.IntegrationsService.DeleteWorkspaceTenant
	 */
	deleteWorkspaceTenant: {
		methodKind: "unary";
		input: typeof DeleteWorkspaceTenantRequestSchema;
		output: typeof DeleteWorkspaceTenantResponseSchema;
	};
	/**
	 * @generated from rpc integrations.v1.IntegrationsService.SaveWorkspaceTenant
	 */
	saveWorkspaceTenant: {
		methodKind: "unary";
		input: typeof SaveWorkspaceTenantRequestSchema;
		output: typeof SaveWorkspaceTenantResponseSchema;
	};
	/**
	 * @generated from rpc integrations.v1.IntegrationsService.SaveSyncResult
	 */
	saveSyncResult: {
		methodKind: "unary";
		input: typeof SaveSyncResultRequestSchema;
		output: typeof SaveSyncResultResponseSchema;
	};
	/**
	 * @generated from rpc integrations.v1.IntegrationsService.GetMostRecentSyncResult
	 */
	getMostRecentSyncResult: {
		methodKind: "unary";
		input: typeof GetMostRecentSyncResultRequestSchema;
		output: typeof GetMostRecentSyncResultResponseSchema;
	};
	/**
	 * @generated from rpc integrations.v1.IntegrationsService.GetSyncSummary
	 */
	getSyncSummary: {
		methodKind: "unary";
		input: typeof GetSyncSummaryRequestSchema;
		output: typeof GetSyncSummaryResponseSchema;
	};
	/**
	 * @generated from rpc integrations.v1.IntegrationsService.SendProxyRequest
	 */
	sendProxyRequest: {
		methodKind: "unary";
		input: typeof ProxyRequestSchema;
		output: typeof ProxyResponseSchema;
	};
}> = /*@__PURE__*/ serviceDesc(file_integrations_v1_service, 0);
